<template >
  <div
    style="
      height: calc(100vh - 60px);
      font-size: 43px;
      color: white;
      max-width: 590px;
      font-family: sans-serif;
    "
  >
    <div class="logoRN">
      <img src="../../../static/img/logorn.png" alt="" />
    </div>
    <div
      class="row align-items-center text-center nahalMerhavia m-0"
      style="height: 30%"
      @click="openNahalMerhavia"
    >
      <div class="col-12">נחל מרחביה</div>
      <div class="tourLenght col-12">אורך: 1.5 ק"מ</div>
    </div>
    <div
      class="row align-items-center text-center nahalMassha m-0"
      style="height: 30%"
      @click="openNahalMassha"
    >
      <div class="col-12">נחל מסחה</div>
      <div class="tourLenght col-12">אורך: 3.5 ק"מ</div>
    </div>
    <div
      class="row align-items-center text-center parkTavor m-0"
      style="height: 30%"
      @click="openParkTavor"
    >
      <div class="col-12">
        <div class="textDarkGeneva">על ידי ילדים של בית ספר ....</div>
        פארק תבור
      </div>
      <div class="tourLenght col-12">אורך: 1.5 ק"מ</div>
    </div>
    <div
      class="row align-items-center text-center einDorNahalTavor m-0"
      style="height: 30%"
      @click="openEinDorNahalTavor"
    >
      <div class="col-12">
        <div class="textDarkGeneva" style="font-size: 19px; top: 17px">
          דרך נחל תבור
        </div>
        עין דור - דבוריה
      </div>
      <div class="tourLenght col-12">אורך: 2.9 ק"מ</div>
    </div>

    <div
      class="row align-items-center text-center kfarKish m-0"
      style="height: 30%"
      @click="openKfarKish"
    >
      <div class="col-12">כפר קיש</div>
      <div class="tourLenght col-12">אורך: 1.8 ק"מ</div>
    </div>
    <div
      class="row align-items-center text-center kfarMassar m-0"
      style="height: 30%"
      @click="openKfarMassar"
    >
      <div class="col-12">{{ lang }}{{ translation.kfarMasser }}</div>
      <div class="tourLenght col-12">אורך: 2.1 ק"מ</div>
    </div>

    <div class="row align-items-center text-center m-0">
      <div class="col-6 footer">© 2025 eifoany</div>
      <div class="col-6 footer">eifoany@gmail.com</div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      navigationName: "",
      translation: {
        kfarMasser: "כפר מסר",
      },
    };
  },
  computed: {
    error() {
      return this.$store.getters.error;
    },
    lang() {
      return this.translate(this.$store.getters.lang);
    },
    // loading() {
    //   return this.$store.getters.loading;
    // }
  },

  methods: {
    translate(lang) {
      if (lang == "fr") {
        this.translation = {
          kfarMasser: "כפר מסר",
        };
      } else {
        this.translation = {
          kfarMasser: "כפר מסר",
        };
      }
    },

    openNahalMassha() {
      this.$router.push("/nahalMassha");
    },
    openEinDorNahalTavor() {
      this.$router.push("/einDorNahalTavor");
    },
    openNahalMerhavia() {
      this.$router.push("/nahalMerhavia");
    },
    openKfarMassar() {
      this.$router.push("/kfarMassar");
    },
    openKfarKish() {
      this.$router.push("/kfarKish");
    },
    openParkTavor() {
      this.$router.push("/parkTavor");
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
.logoRN {
  position: absolute;
  top: 0px;
}
.logoRN img {
  height: 50px;
}
.tourLenght {
  font-size: 20px;
}
#goToDoItYourself {
  position: fixed;
  background-color: rgba(84, 163, 49, 80%);
  width: 80px;
  height: 80px;
  border: solid 2px white;
  border-radius: 82px;
  bottom: 28px;
  font-size: 12px;
  color: white;
  right: 10px;
}
.footer {
  max-height: 30px;
  font-size: 15px;
  background: #3369bc;
}
.parkTavor {
  background: url("../../../static/img/parkTavor.png") no-repeat center center;
  background-size: cover;
}
.textDarkGeneva {
  font-size: 14px;
  text-align: center;
  margin: 0 auto;
  top: 11px;
  position: relative;
}
.kfarKish {
  background: url("../../../static/img/kish.jpg") no-repeat center center;
  background-size: cover;
}
.kfarMassar {
  background: url("../../../static/img/massar.jpg") no-repeat center center;
  background-size: cover;
}

.einDorNahalTavor {
  background: url("../../../static/img/einDorNahalTavor.jpeg") no-repeat center 61%;
  background-size: cover;
}
.nahalMerhavia {
  background: url("../../../static/img/merhavia.png") no-repeat center 68%;
  background-size: cover;
}
.nahalMerhavia::before {
  filter: brightness(50%);
}
.nahalMassha {
  background: url("../../../static/img/nahalMassha.jpg") no-repeat -33% 37%;
  background-size: cover;
}
.myModal {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: white;
}
.over {
  position: fixed;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
}
.colorBtn {
  border-radius: 36px;
  height: 56px;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.center {
  display: block;
  margin: 0px auto;
}
/*This is the code to make the spinner spin*/
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



